<div class="contact">
  <h2>Contact</h2>
  <div class="contact-details">
    <div>
      <img src="/icons/mail-small.png" alt="mail-icon" class="icon" />
      <a href={null} on:click="{() => openMail('erawtfos.diuqs@naitsirhc')}" class="ltr">
        erawtfos.diuqs@naitsirhc
      </a>
    </div>
    <div>
      <img src="/icons/phone-small.png" alt="phone-icon" class="icon" />
      <a href={null} on:click="{() => openTel('20063411-60')}" class="ltr">
        20063411-60
      </a>
    </div>
  </div>
</div>

<style>
  .contact {
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .contact .icon {
    max-height: 20px;
  }
  .contact-details div {
    display: flex;
    justify-content: center;
  }
  .contact div a {
    color: var(--primary-color);
    padding-left: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .ltr {
    unicode-bidi: bidi-override;
    direction: rtl;
  }
  @media(max-width: 600px) {
    .contact {
      margin-top: 50px;
      margin-bottom: 100px;
    }
  }
</style>

<script>
  function openMail(email) {
    window.location.href = `mailto:${email.split('').reverse().join('')}`
  }
  function openTel(tel) {
    window.location.href = `tel:${tel.split('').reverse().join('')}`
  }
</script>